module.exports = "<div #olMap></div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/open-layers-map/openlayers-map/openlayers-map.component.html
// module id = ../../../../../src/app/packages/open-layers-map/openlayers-map/openlayers-map.component.html
// module chunks = main